export const FEATURES = {
  /**
   * Habilita assinaturas Stripe para prestadores
   * Quando false: não redireciona provider sem assinatura para planos, oculta card "Minha Assinatura"
   * Em prod: manter false até validar; ativar com EXPO_PUBLIC_STRIPE_SUBSCRIPTIONS_ENABLED=true
   */
  STRIPE_SUBSCRIPTIONS: process.env.EXPO_PUBLIC_STRIPE_SUBSCRIPTIONS_ENABLED === 'true',

  /**
   * Provedor WhatsApp ativo: 'meta' (padrão) | 'evolution'
   * Quando 'evolution': exibe WhatsappConnectCard no perfil do prestador.
   * Configurar EXPO_PUBLIC_WHATSAPP_PROVIDER=evolution para habilitar self-service.
   */
  WHATSAPP_PROVIDER: process.env.EXPO_PUBLIC_WHATSAPP_PROVIDER ?? 'meta',
};
